require ('es7-object-polyfill')
module.exports = class QuestionFilter {

    constructor (questions) {
        this.questions = questions;
        this.skipSections = {};
    }

    get skipSectionsList () {
        return Object.values(this.skipSections);
    }

    get questionList () {

        const result = this.questions
            .filter(question =>
                this.skipSectionsList
                    .reduce((acc, val) => acc.concat(val), [])
                    .indexOf(parseInt(question.sectionId)) === -1);
        return result ;
    }

    get length () {
        return this.questionList.length;
    }

    getByIndex (index) {
        return this.questionList[index];
    }

    addSkip (index, sectionId) {
        if ( sectionId === 0 ) {
            delete this.skipSections[index];
        } else {
            this.skipSections[index] = sectionId;
        }
    }

}